export default __webpack_public_path__ + "static/media/Raider's Leggings of the Covert Trail.667785f4.jpg";